import React from 'react';
import { withRouter } from 'react-router-dom';
import Grid from './Grid.jsx';

class TiposConta extends React.Component {

    constructor() {

        super();

        this.state = {
            gridHeader: [
                "Nome",
                "Código",
                "Corrente" ],
            tiposConta: [],
            centroId: 0,
            centro: ""
        };

        this.voltar = this.voltar.bind(this);
        this.cadastrar = this.cadastrar.bind(this);

    }

    voltar() {

        let obj = {
            row: {
                id: this.state.centroId,
                data: [ this.state.centro ]
            }
        };

        this.props.history.push({
            pathname: "/contascentro",
            state: obj
        });

    }

    cadastrar() {

        let obj = {
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/cadastrartipoconta",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleContas === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/contas";
        }

        let cId = this.props.location.state.centroId;
        let centroNome = this.props.location.state.centro;
        this.setState({ centroId: cId });
        this.setState({ centro: centroNome });

        fetch("/api/tipo_conta/grid/" + cId, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ tiposConta: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="tiposconta-title">Tipos de Conta</h1><br />
                <br />
                <p id="tiposconta-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br />
                <Grid key={ this.state.tiposConta }
                    header={ this.state.gridHeader }
                    data={ this.state.tiposConta }
                    pageSize={ 10 }
                    gridWidth={ "800px" }
                    linkTo={ "/visualizartipoconta" } />
                <br />
                <button id="tiposconta-voltar-btn" onClick={ this.voltar }>
                    Voltar
                </button>
                { localStorage.roleContas === "escrever" &&
                    <button id="tiposconta-cadastrar-btn" onClick={ this.cadastrar }>
                        Cadastrar Tipo de Conta
                    </button> }
                <br /><br />
            </div>
        );
    }

}

export default withRouter(TiposConta);

